import { request } from '@/network/request'

export const userDataReport = (id) => {
  return request({
    url: '/intelligentDetection/user/userDataReport?userId=' + id,
    method: 'get',
  })
}

// 商品列表
/*export const getCommodityList = () => {
  return request({
    url: '/api/commodity/aiCommodity/getCommodityList',
    method: 'get',
  })
}*/
export const getCommodityList = (data) => {
  return request({
    url: '/api/commodity/aiCommodity/specialRecharge',
    method: 'post',
    data: data
  })
}

// 商品列表1

export const getCommodityList1 = (data) => {
  return request({
    url: '/api/commodity/aiCommodity/getCommodityList',
    method: 'get',
    //data: data
  })
}
/// 判断用户是否是会员、推广主
export const vipCenter = () => {
  return request({
    url: '/userVip/vipOrder/vipCenter',
    method: 'get',
  })
}

/// 获取用户积分、连续签到天数等
export const signIntegral = (data) => {
  return request({
    url: '/api/userSign/signIntegral',
    method: 'post',
    data
  })
}

// 积分兑换
export const creditsExchang = (data) => {
  return request({
    url: '/api/userSign/creditsExchange',
    method: 'post',
    data
  })
}

// 签到
export const doSign = (data) => {
  return request({
    url: '/api/userSign/doSign',
    method: 'post',
    data
  })
}

// 个人中心：推广主粉丝数量、今日收益
export const personalCenter = (data) => {
  return request({
    url: '/api/promoters/tWzaiAiProduct/personalCenter',
    method: 'post',
    params: data
  })
}

// 专属导师
export const exclusiveTutor = (data) => {
  return request({
    url: '/api/promoters/tWzaiAiProduct/exclusiveTutor',
    method: 'post',
    params: data
  })
}


// 粉丝、收益历史
export const fansRevenueHistory = (data) => {
  return request({
    url: '/api/promoters/tWzaiAiProduct/fansRevenueHistory',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/memberCenter.js